import { Typography } from '../Typography';

import { Wrapper } from './styled';
import type { Props } from './types';

export function NoticeCard({ text, title }: Props) {
  return (
    <Wrapper>
      <Typography.Text
        color="gray-700"
        paddingBottom="grid-16"
        sx={{
          display: 'block',
          maxWidth: '400px',
        }}
        variant="textStyles.medium-20/140%"
      >
        {title}
      </Typography.Text>
      <Typography.Text
        color="gray-600"
        paddingBottom="grid-36"
        sx={{
          display: 'block',
        }}
        variant="textStyles.medium-16/140%"
      >
        {text}
      </Typography.Text>
    </Wrapper>
  );
}
